import React, { useState } from "react";
import filterimg from "../../assets/images/filter.svg";


import usePilotAvailableJobs from "hooks/usePilotAvailableJobs";
import JobCard from "components/Dashboard/JobCard";
import { Col, Row } from "react-bootstrap";
import BidNowForm from "components/Modals/FormPopup/BidNowForm";


const AvailableJobs = () => {
    const [dataLength, setDataLength] = useState({
        skip: 0,
        limit: 9
    })
    const [bidNowModal, setBidNowModal] = useState(false);
    const [selectedJobId, setSelectedJobId] = useState(null);
    const { jobsData } = usePilotAvailableJobs(dataLength);
    const { totalAvailableJobs, availableJobs } = jobsData;

    const handleShow = (id) => {
        setBidNowModal(true);
        setSelectedJobId(id)
    }

    const handleClose = () => {
        setBidNowModal(false);
    }

    const handleViewMore = () => {
        const data = dataLength;
        setDataLength({
            ...data,
            limit: data?.limit + 9
        })
    }

    return (
        <div className="container-box available-jobs">
            <div className="top-head d-flex flex-wrap justify-content-between align-items-center text-white">
                <div className="d-flex">
                    <h2>Available Jobs</h2>
                    <span className="bedge-green">
                        {totalAvailableJobs}
                    </span>
                </div>
                {/* <div className="filterdiv">
                    <img src={filterimg}  alt=""/>
                </div> */}
            </div>

            <div className="my-job-tabs" style={{ maxHeight: "100vh", overflowY: "auto" }}
                onScroll={(e) => {
                    const target = e.currentTarget;
                    if (target.scrollHeight - target.scrollTop === target.clientHeight) {
                        handleViewMore(); // load more when scrolled to bottom
                    }
                }}>
                <div>
                    <Row>
                        {availableJobs?.length > 0 && availableJobs?.map((item, idx) => {
                            return (
                                <Col xl={4} lg={6} key={item?._id}>
                                    <JobCard
                                        item={item}
                                        handleShow={handleShow}
                                    />
                                </Col>
                            )
                        })}
                    </Row>
                </div>
                {/* {availableJobs?.length < totalAvailableJobs && <div className="d-flex flex-wrap gap-2 justify-content-center">
                    <button className=" blue-btnnn text-white" onClick={handleViewMore}>
                        View More
                    </button>
                </div>} */}
            </div>

            <BidNowForm
                show={bidNowModal}
                handleClose={handleClose}
                selectedJobId={selectedJobId}
            />
        </div>
    );
};

export default AvailableJobs;
